import React from 'react';
import { getLabelEstadoById } from "../../../helper/ordenHelper";
import { formatoFechaSinHora } from "../../../utilities/formatoFecha";
import PropTypes from "prop-types";

export default function EstadoListItem({ idEstado, fecha, children }) {
  return (
    <div className="row align-items-center text-center mb-0 mb-lg-2">
      <div className="col-12 col-sm-3 text-center orden-estado-label-wrap px-1">
        <span className={`label label-${getLabelEstadoById(idEstado).color} orden-estado-label`}>
          {getLabelEstadoById(idEstado).label}
        </span>
      </div>
      <div className="col-12 col-sm-2">
        <p className="d-inline small">{formatoFechaSinHora(fecha)}</p>
      </div>
      {children}
    </div>
  )
}
EstadoListItem.propTypes = {
    fecha: PropTypes.string,
    idEstado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    children: PropTypes.array,
}